export default __webpack_public_path__ + "static/techDataLogo-66496e9d0bf64d8bdf1ebaec64f47779.png";